import AccountCompliancePage from "@pages/account-compliance/AccountCompliancePage"
import {
	SHOW_ITINERARY,
	SHOW_REDUCED_RATES,
	SHOW_CONTACT_US,
	SHOW_QUICK_REFERENCE,
	SHOW_GROUP_TRAVEL_HUB,
	SHOW_GROUP_DINING,
	SHOW_MICROSITES,
	SHOW_MMC
} from "@utils/constants.util"
import { lazy } from "react"

const OTPProxyPage = lazy(() => import("../pages/proxy/OTPProxyPage"))
const AgentRegisterPage = lazy(
	() => import("../pages/agent-register/AgentRegisterPage")
)
const AgentRegisterStepper = lazy(
	() => import("../pages/agent-register/AgentRegisterStepper")
)
const AgencyRegisterPage = lazy(
	() => import("../pages/agency-register/AgencyRegisterPage")
)

const AgencyRegisterSalesAgreement = lazy(
	() =>
		import("../pages/agency-register/flow-pages/AgencyRegisterSalesAgreement")
)
const AgencyEmailVerification = lazy(
	() => import("../pages/agency-register/flow-pages/AgencyEmailVerification")
)
const AgencyEmailLinkSent = lazy(
	() => import("../pages/agency-register/flow-pages/AgencyEmailLinkSent")
)
const AgencyEmailLinkResend = lazy(
	() => import("../pages/agency-register/flow-pages/AgencyEmailLinkResend")
)
const RegisterAgencyWelcomeStep = lazy(
	() => import("../pages/agency-register/flow-pages/AgencyEmailWelcome")
)
const Login = lazy(() => import("../pages/login/Login"))
const ForgotAccount = lazy(() => import("../pages/account/ForgotAccount"))
const ForgotPassword = lazy(
	() => import("../pages/account/password/ForgotPassword")
)
const EmailVerified = lazy(
	() => import("../pages/account/password/EmailVerified")
)

const ResetPassword = lazy(
	() => import("../pages/account/password/ResetPassword")
)
const ResetSuccess = lazy(
	() => import("../pages/account/password/ResetSuccess")
)
const ForgotUsername = lazy(
	() => import("../pages/account/username/ForgotUsername")
)
const UsernameRecovery = lazy(
	() => import("../pages/account/username/UsernameRecovery")
)
const PhoneVerification = lazy(
	() => import("../pages/account/username/PhoneVerification")
)
const Home = lazy(() => import("../pages/home/home"))
const WelcomePage = lazy(() => import("../pages/WelcomePage/WelcomePage"))
const SuperUserPage = lazy(
	() => import("../pages/login/super-user/SuperUserPage")
)
const SuperUserAgencyFoundPage = lazy(
	() => import("../pages/login/super-user/SuperUserAgencyFoundPage")
)

const Logout = lazy(() => import("../pages/logout"))
const SeeOurShips = lazy(
	() => import("../pages/see-our-ships/SeeOurShipsRouting")
)
const PromotionHome = lazy(() => import("../pages/promotions/PromotionHome"))
const PromotionBrand = lazy(() => import("../pages/promotions/PromotionBrand"))
const PromotionsSearchResults = lazy(
	() => import("../pages/promotions/PromotionsSearchResults")
)
const PromotionDetail = lazy(
	() => import("../pages/promotions/PromotionDetail")
)
const PromotionFeaturedOffers = lazy(
	() => import("../pages/promotions/PromotionFeaturedOffers")
)
const PromotionArchived = lazy(
	() => import("../pages/promotions/PromotionArchived")
)
const PromotionOffersList = lazy(
	() => import("../pages/promotions/PromotionOffersList")
)
const SearchItineraries = lazy(
	() => import("../pages/itineraries/SearchItineraries")
)
const ItineraryResults = lazy(
	() => import("../pages/itineraries/ItineraryResults")
)
const ItineraryDetail = lazy(
	() => import("../pages/itineraries/ItineraryDetail")
)
const ItineraryCompare = lazy(
	() => import("../pages/itineraries/ItineraryCompare")
)
const InsightsHome = lazy(() => import("../pages/insights/InsightsHome"))
const ReducedRates = lazy(() => import("../pages/reduced-rates/ReducedRates"))
const TermsOfUse = lazy(() => import("../pages/terms-of-use/TermsOfUse"))
const PrivacyPolicy = lazy(
	() => import("../pages/privacy-policy/PrivacyPolicy")
)
const TravelAgentGuidelines = lazy(
	() => import("../pages/agent-guidelines/TravelAgentGuidelines")
)
const ErrorPage = lazy(() => import("../pages/error/ErrorPage"))
const UserManagementPage = lazy(
	() => import("../pages/user-management/UserManagement")
)

const OneStopPricingPage = lazy(
	() => import("../pages/one-stop-pricing/OneStopPricing")
)

const GroupTravelHubPage = lazy(
	() => import("../pages/group-travel-hub/GroupTravelHub")
)

const QuickReferencePage = lazy(
	() => import("../pages/quick-reference/QuickReference")
)

const ProfileManagmentPage = lazy(
	() => import("../pages/profile-managment/profileManagment")
)
const TravelDocsPage = lazy(() => import("../pages/travel-docs/TravelDocs"))
const TravelDocsPreviewHTML = lazy(
	() => import("../pages/travel-docs/TravelDocsPreview/TravelDocsPreviewHTML")
)

const CertificateRedemptionHome = lazy(
	() => import("../pages/certificate-redemption/CertificateRedemptionHome")
)
const AlertsPage = lazy(() => import("../pages/alert-center/LatestAlerts"))
const GroupDining = lazy(() => import("../pages/group-dining/GroupDining"))
const GroupSummary = lazy(
	() =>
		import(
			"../pages/group-dining/components/GuestTableAllocator/GuestTableAllocatorChanged"
		)
)
const Microsites = lazy(() => import("../pages/microsites/Microsites"))
const ContactPage = lazy(() => import("../pages/contact/ContactPage"))
const CallbackPage = lazy(() => import("../pages/oauth/CallbackPage"))
const EmailOptOut = lazy(
	() => import("../pages/email-opt-out/EmailOptOutWrapper")
)
const RedirectPage = lazy(() => import("../pages/redirect/RedirectPage"))

const GroupSummaryReview = lazy(
	() =>
		import(
			"../pages/group-dining/components/GuestTableAllocatorReview/GuestTableAllocatorReview"
		)
)

const GlobalSearch = lazy(() => import("../pages/global-search/GlobalSearch"))

const MyMarketingCenter = lazy(
	() => import("../pages/my-marketing-center/MyMarketingCenter")
)
// Authenticated routes
// Check ROUTE_TOOL_CODE_MAP to add tool codes to the routes
export const homeRoutes = [
	{ path: "/home", component: Home },
	{ path: "/welcome", component: WelcomePage }
]

export const logoutRoutes = [{ path: "/logout", component: Logout }]

export const superUserRoutes = [
	{ path: "/super-user", component: SuperUserPage },
	{ path: "/super-user/agency-found", component: SuperUserAgencyFoundPage }
]

export const exploreOurFleetRoutes = [
	{ path: "/explore-our-fleet/*", component: SeeOurShips }
]

export const promotionRoutes = [
	{ path: "/promotion/home", component: PromotionHome },
	{ path: "/promotion/brand", component: PromotionBrand },
	{ path: "/promotion/results", component: PromotionsSearchResults },
	{ path: "/promotion/detail", component: PromotionDetail },
	{ path: "/promotion/featured-offers", component: PromotionFeaturedOffers },
	{ path: "/promotion/archived-offers", component: PromotionArchived },
	{ path: "/promotion/offers-list", component: PromotionOffersList }
]

export const insightsRoutes = [{ path: "/insights/*", component: InsightsHome }]

export const userManagementRoutes = [
	{ path: "/user-management/*", component: UserManagementPage }
]

export const groupTravelHubRoutes = [
	{ path: "/group-travel-hub/*", component: GroupTravelHubPage }
]

export const oneStopPricingRoutes = [
	{ path: "/one-stop-pricing", component: OneStopPricingPage }
]

export const quickReferenceRoutes = [
	{ path: "/quick-reference/*", component: QuickReferencePage },
	{ path: "/quick-reference/royal/*", component: QuickReferencePage },
	{ path: "/quick-reference/celebrity/*", component: QuickReferencePage }
]

export const profileManagementRoutes = [
	{ path: "/profile/*", component: ProfileManagmentPage }
]

export const complianceRoutes = [
	{ path: "/account-compliance", component: AccountCompliancePage }
]

export const certificateRedemptionRoutes = [
	{ path: "/certificate-redemption", component: CertificateRedemptionHome }
]

export const travelDocsRoutes = [
	{ path: "/travel-docs/*", component: TravelDocsPage }
]

export const alertsRoutes = [{ path: "/alerts", component: AlertsPage }]

export const itineraryRoutes = [
	{ path: "/itinerary/search", component: SearchItineraries },
	{ path: "/itinerary/results", component: ItineraryResults },
	{ path: "/itinerary/detail", component: ItineraryDetail },
	{ path: "/itinerary/compare", component: ItineraryCompare }
]

export const reducedRatesRoutes = [
	{ path: "/reduced-rates/*", component: ReducedRates }
]

export const contactUsRoutes = [
	{ path: "/contact/:brand", component: ContactPage }
]

export const agentRegistrationRoutes = [
	{ path: "/register", component: AgentRegisterPage },
	{ path: "/register/stepper", component: AgentRegisterStepper }
]

export const agencyRegistrationRoutes = [
	{ path: "/register-agency", component: AgencyRegisterPage },
	{ path: "/register-agency/stepper", component: AgencyRegisterPage },
	{ path: "/register-agency/stepperSuccess", component: AgencyRegisterPage },
	{ path: "/register-agency/verify", component: AgencyEmailVerification },
	{ path: "/register-agency/email-sent", component: AgencyEmailLinkSent },
	{ path: "/register-agency/email-resend", component: AgencyEmailLinkResend },
	{ path: "/register-agency/welcome", component: RegisterAgencyWelcomeStep }
]

export const forgotAccountRoutes = [
	{ path: "/account/forgot", component: ForgotAccount },
	{ path: "/account/forgot/password", component: ForgotPassword },
	{ path: "/account/forgot/password/email-verified", component: EmailVerified },
	{ path: "/account/forgot/password/reset-password", component: ResetPassword },
	{ path: "/account/forgot/password/reset-success", component: ResetSuccess },
	{ path: "/account/forgot/username", component: ForgotUsername },
	{ path: "/account/forgot/username/recovery", component: UsernameRecovery },
	{
		path: "/account/forgot/username/phone-verification",
		component: PhoneVerification
	}
]

export const termsAndCondRoutes = [
	{ path: "/terms-of-use", component: TermsOfUse },
	{ path: "/privacy-policy", component: PrivacyPolicy },
	{ path: "/travel-agent-guidelines", component: TravelAgentGuidelines }
]

export const salesAgreementRoutes = [
	{
		path: "/register-agency/sales-agreement",
		component: AgencyRegisterSalesAgreement
	}
]

export const loginRoutes = [{ path: "/login", component: Login }]

export const standAloneRoutes = [
	...loginRoutes,
	{ path: "/CPOptOut.do", component: EmailOptOut },
	{ path: "/otp-verify", component: OTPProxyPage },
	{ path: "/travel-docs/html/preview", component: TravelDocsPreviewHTML },
	{ path: "/oauth/callback", component: CallbackPage }
]

export const redirectRoutes = [{ path: "/redirect", component: RedirectPage }]

export const conditionalPageLayoutRoutes = [...termsAndCondRoutes]

export const pageWithHeaderCloseButtonRoutes = [...salesAgreementRoutes]

export const pageWithHeaderBackButtonRoutes = [
	...agencyRegistrationRoutes,
	...agentRegistrationRoutes,
	...forgotAccountRoutes
]

export const groupDiningRoutes = [
	{ path: "/dining", component: GroupDining },

	{
		path: "/dining/group-summary-review/:groupId",
		component: GroupSummaryReview
	},
	{ path: "/dining/group-summary/:groupId", component: GroupSummary }
]

export const micrositesRoutes = [
	{ path: "/sites/:brand/*", component: Microsites }
]

export const globalSearchRoutes = [
	{ path: "/global-search", component: GlobalSearch }
]

export const myMarketingCenterRoutes = [
	{ path: "/my-marketing-center", component: MyMarketingCenter }
]

export const authenticatedRoutes = [
	...homeRoutes,
	...logoutRoutes,
	...superUserRoutes,
	...redirectRoutes,
	...exploreOurFleetRoutes,
	...promotionRoutes,
	...insightsRoutes,
	...userManagementRoutes,
	...profileManagementRoutes,
	...certificateRedemptionRoutes,
	...travelDocsRoutes,
	...alertsRoutes,
	...itineraryRoutes,
	...reducedRatesRoutes,
	...(SHOW_GROUP_DINING ? groupDiningRoutes : []),
	...oneStopPricingRoutes,
	...oneStopPricingRoutes,
	...(SHOW_MICROSITES ? micrositesRoutes : []),
	...(SHOW_ITINERARY ? itineraryRoutes : []),
	...(SHOW_REDUCED_RATES ? reducedRatesRoutes : []),
	...(SHOW_CONTACT_US ? contactUsRoutes : []),
	...(SHOW_QUICK_REFERENCE ? quickReferenceRoutes : []),
	...(SHOW_GROUP_TRAVEL_HUB ? groupTravelHubRoutes : []),
	...complianceRoutes,
	...globalSearchRoutes,
	...(SHOW_MMC ? myMarketingCenterRoutes : [])
]

export { WelcomePage, ErrorPage }
